export interface ManualCardStartActivity {
  url: string;
  activityUrn: string;
  contextId: string;
  success: boolean;
}

export interface ManualCardPaymentStoreStartActivity {
  url: string;
  activityUrn: string;
  contextId: string;
  success: boolean;
}

export interface ManualCardActivityResult {
  data?: { cardDetails: CardDetails; cardAttributes: CardAttributes };
  errors: string;
  handleEdit?: () => void;
  hideEdit?: boolean;
  success: boolean;
}

export interface StoredCardResult {
  data?: { cardDetails: CardDetails; cardAttributes: CardAttributes };
  errors: string;
  success: boolean;
  isExpired:boolean;
  deleteCard?: () => void;
  updateCard?:() => void;
}

export interface CardDetails {
  nameProvided: string;
  maskedCardNumber: string;
  expiration: CardExpiration;
}
export interface CardExpiration {
  lastValidMonth: number;
  year: number;
}

export interface CardAttributes {
  cardBrand: string;
  cardIssuer: string;
}
export const ManualCardStartActivityInitialState: ManualCardStartActivity = {
  url: "",
  activityUrn: "",
  contextId: "",
  success: false,
};

export const ManualCardPaymentStoreStartActivityInitialState: ManualCardPaymentStoreStartActivity =
  {
    url: "",
    activityUrn: "",
    contextId: "",
    success: false,
  };

export interface Payment {
  activityUrn: string;
  contextId: string;
  cardNumber?: string;
  cardExpiry?: string;
  cardBrand?: string;
  transactionalProfileId? : string;
  walletInstrument?: string;
}

export interface PaymentResultProps {
  cardNumber?: string;
  cardExpiry?: string;
  cardBrand?: string;
  savedPayment: boolean;
}

export interface StoredCardDetails {
  userId?: number;
  firstName?: string;
  lastName?: string;  
  contextId?: string;
  data : { urn? :string; cardDetails : CardDetails; cardAttributes: CardAttributes; type?:string; cardToken?:string;}
  errors :string;
  hasStoredCard: boolean;
  success: boolean;
}
export interface StoredCardDetailProps {
  data : StoredCardDetails | null,
  canContinue: (data:any) => void;
  updateStoredCardFlag: (data:boolean) => void;
  isBobo: boolean;
}
export interface MyPaymentMethodType {
  isExpired: boolean;
  onCardUpdated?: () => void;
  onCardDeleted?: () => void;
}

export interface CCProfileType {
  alertMessage: string| null;
  onAlertDisplayed?:()=>void;
}